export default __webpack_public_path__ + "img/financial-modelling.66e777ea.jpg";